import React from 'react';
import { useNavigate } from 'react-router-dom';

const Footer = ({
  totalPrice,
  quotationId,
  onCustomizeClick,
  customizeButtonText = "Customize",
  proceedButtonText = "Proceed",
  showCustomizeButton = true
}) => {
  const navigate = useNavigate();

  const handleProceed = () => {
    navigate('/consumer/app/proceed', { state: { quotationId } });
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg p-4 flex justify-between items-center border-t border-gray-300">
      {/* Price section */}
      <div className='flex flex-col'>
        <p className="text-md font-semibold">Total Price</p>
        <p className='text-xl text-[#14A311] font-bold'>₹{totalPrice.toLocaleString('en-IN')} /- </p>
        <span className="text-xs text-gray-500 mt-0.1">(+ GST & Transport)</span>
      </div>
      
      {/* Buttons section */}
      <div className="flex flex-col">
        {showCustomizeButton && (
          <button
            onClick={onCustomizeClick}
            className="border border-[#C20C0C] text-[#C20C0C] font-medium py-1 px-4 rounded-md mb-1"
          >
            {customizeButtonText}
          </button>
        )}
        
        <button
          className="bg-[#C20C0C] text-white font-medium py-2 px-4 rounded-md"
          onClick={handleProceed}
        >
          <div className="flex flex-col items-center leading-tight">
              <span>{proceedButtonText}</span>
          </div>
        </button>
      </div>
    </div>
  );
};

export default Footer;
